import CrudCustom from '../../../libs/custom/CrudCustom';

let PPh21FinalService = new CrudCustom('/p-ph-21-finals');
export default PPh21FinalService;
